/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Action_View_TaskInputs */

const en_notifications_action_view_task = /** @type {(inputs: Notifications_Action_View_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View task`)
};

const pt_br2_notifications_action_view_task = /** @type {(inputs: Notifications_Action_View_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver atividade`)
};

/**
* | output |
* | --- |
* | "View task" |
*
* @param {Notifications_Action_View_TaskInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_action_view_task = /** @type {((inputs?: Notifications_Action_View_TaskInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Action_View_TaskInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_action_view_task(inputs)
	return pt_br2_notifications_action_view_task(inputs)
});